import type { ReactNode } from 'react';
import { Box, Link } from '@mui/material';

export interface IconTextProps {
  title?: string;
  icon: ReactNode;
  text: string;
  href?: string;
  color?: string;
}

const IconText = ({
  title,
  icon,
  text,
  href,
  color = 'text.secondary',
}: IconTextProps) => (
  <Box
    component="span"
    title={title}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      color,
    }}
  >
    {icon}
    <Link
      component={href ? 'a' : 'span'}
      {...(href && { href })}
      variant="body2"
      color="inherit"
      underline={href ? 'hover' : 'none'}
    >
      {text}
    </Link>
  </Box>
);

export default IconText;
